/**
 * This build's deployment config (the demo `dev` vs the `v1` link — see
 * @bento/shared config/deployments.ts). VITE_APP_STAGE is baked in per stage by
 * infra; unset (local dev, tests) → the demo. The legacy menu reads the same
 * config via `window.bentoDeployment` (injected by vite.config.ts).
 */

import { getDeployment, enabledWidgetTitles } from "@bento/shared";

/** Can a module with this title be placed on this link? */
export function isTitleAllowed(title: string, stage = import.meta.env.VITE_APP_STAGE): boolean {
  const titles = enabledWidgetTitles(getDeployment(stage));
  return titles === null || titles.includes(title);
}
